class NavigationHover {
  constructor(el) {
    this.el = el;
    this.isAnimating = false;
    
    this.init();
  }

  init() {
    this.el.addEventListener('mouseenter', () => {
      this.startAnimation();
    });
  }

  startAnimation() {
    // 既にアニメーション中の場合は何もしない
    if (this.isAnimating) return;
    
    this.isAnimating = true;
    
    // アニメーションクラスを追加
    this.el.classList.add('is-animating');
    
    // アニメーション終了後にクラスを削除
    setTimeout(() => {
      this.el.classList.remove('is-animating');
      this.isAnimating = false;
    }, 800); // var(--duration-slow)の時間に合わせる
  }
}

export default NavigationHover;
